import { useCallback } from "react";
import { apiMain } from "@/common/services";
import { setUserData } from "@/common/utils/storage";
import { useUserStore } from "@/common/store";

interface IProps<T> {
  updateRequest: (data: T) => Promise<void>;
}

export const useUpdateUserData = <T>({ updateRequest }: IProps<T>) => {
  const setCurrentUser = useUserStore((state) => state.setCurrentUser);

  const updateUserData = useCallback(async (params: T) => {
    await updateRequest(params);
    const data = await apiMain.getMe();
    setCurrentUser(data);
    setUserData(data);
  }, [updateRequest]);

  return {
    updateUserData,
  };
};
